import React from 'react';
import { Box, Tab } from '@mui/material';
import { UserTable } from './UserTable';
import { PlatformDetail } from './PlatformsDetail';
import { TabLabel } from '@/types';
import { FloatingLine, ManagementTabs } from '../styles';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function accessibilityProps(index: number) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

type Props = {
  selectedGroupID: string;
  innerTab: number;
  handleTabChange: (event: React.SyntheticEvent, value: number) => void;
  handleAllowGroupDelete: (value: boolean) => void;
};

export const GroupDetail = ({
  selectedGroupID,
  innerTab,
  handleTabChange,
  handleAllowGroupDelete,
}: Props) => {
  return (
    <Box>
      <Box sx={{ mt: 3 }}>
        <ManagementTabs value={innerTab} onChange={handleTabChange} aria-label="basic tabs example">
          <Tab label="Members" {...accessibilityProps(TabLabel.MEMBER_TAB)} />
          <Tab
            label="Platforms"
            {...accessibilityProps(TabLabel.PLATFORM_TAB)}
            data-testid="platforms-tab"
          />
        </ManagementTabs>
      </Box>
      <FloatingLine />

      {innerTab === TabLabel.MEMBER_TAB && (
        <TabPanel value={innerTab} index={TabLabel.MEMBER_TAB}>
          <UserTable
            selectedGroupID={selectedGroupID}
            handleAllowGroupDelete={handleAllowGroupDelete}
          />
        </TabPanel>
      )}
      {innerTab === TabLabel.PLATFORM_TAB && (
        <TabPanel value={innerTab} index={TabLabel.PLATFORM_TAB}>
          <PlatformDetail selectedGroupID={selectedGroupID} />
        </TabPanel>
      )}
    </Box>
  );
};
